import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=4f66646c&scoped=true"
var script = {}
import style0 from "./AddButton.vue?vue&type=style&index=0&id=4f66646c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66646c",
  null
  
)

export default component.exports